module.exports = "/fonts/Flaticon2.svg?781880ac493782e398be6c6c7245e91b";